<template>
  <span style="text-align:left;">
    <template v-if="modo == 'new' || modo == 'edit' || modo == 'flow'">
      <v-input
        :value="value"
        required
        :rules="crud.evalrules(campo)"
        :hint="T(campo.cmp_dica)"
        persistent-hint
      >
        <datepicker
          class="mt-4"
          v-bind:value="value"
          v-on:input="event => $emit('input', preUpdate(event))"
          placeholder
          :clear-button="true"
          :format="T('dd/MM/yyyy')"
          :language="ptBR"
          input-class="dataCampoInput"
          :default-value="momentMaisUm(defaultValue)"
          @change="mudouMe()"
        ></datepicker>
      </v-input>
    </template>

    <template v-if="modo == 'list' || modo == 'view' || modo == 'viewmode'">
      <span :class="{ 'text-xs-center': modo == 'list' }" v-if="value">{{
        value | moment(T("DD/MM/YYYY") + " HH:mm:ss")
      }}</span>
    </template>

    <template v-if="modo == 'filtro'">
      <el-date-picker
        v-model="desde"
        placeholder="Desde"
        :format="T('dd/MM/yyyy')"
        value-format="yyyy-MM-dd"
        style="width: 130px;"
        type="date"
        size="mini"
        @change="inputChanged"
        input-class="dataCampoInput"
      ></el-date-picker>
      <br />
      <el-date-picker
        v-model="ate"
        placeholder="Até"
        :format="T('dd/MM/yyyy')"
        value-format="yyyy-MM-dd"
        style="width: 130px;"
        type="date"
        size="mini"
        @change="inputChanged"
        input-class="dataCampoInput"
      ></el-date-picker>
    </template>
  </span>
</template>

<script>
import Datepicker from "vuejs-datepicker";

import { ptBR } from "vuejs-datepicker/dist/locale";

try {
  var _baseComponent = require("@/lib/componente/_base.vue").default;
} catch (err) {
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}
export default {
  extends: _baseComponent,
  data() {
    return {
      ptBR,
      desde: this.value != null ? this.value[0] : null,
      ate: this.value != null ? this.value[1] : null
    };
  },
  computed: {
    defaultValue() {
      if (this.getComponentParam("de") != null) {
        return this.row[this.getComponentParam("de")];
      }
      return null;
    }
  },
  methods: {
    mudouMe() {
      if (this.getComponentParam("de") != null) {
        let outro = this.row[this.getComponentParam("de")];

        if (this.value != null && outro != null) {
          if (this.value < outro) {
            this.row[this.getComponentParam("de")] = this.value;
          }
        }
      }
      if (this.getComponentParam("ate") != null) {
        let outro = this.row[this.getComponentParam("ate")];

        if (this.value != null && outro != null) {
          if (this.value > outro) {
            this.row[this.getComponentParam("ate")] = this.value;
          }
        }
      }
    },

    preUpdate(myval) {
      if (myval != null) {
        myval.setHours(new Date().getHours());
        myval.setMinutes(new Date().getMinutes());
        myval.setSeconds(new Date().getSeconds());
      }
      return myval;
    },

    inputChanged() {
      let desde = this.desde;

      try {
        if (desde != null) {
          desde.setHours(0);
          desde.setMinutes(0);
          desde.setSeconds(0);
        }
      } catch (err) {}

      let ate = this.ate;
      try {
        if (ate != null) {
          ate.setHours(23);
          ate.setMinutes(59);
          ate.setSeconds(59);
        }
      } catch (err) {}
      if (this.modo == "filtro")
        setTimeout(
          () =>
            this.$emit(
              "input",
              this.desde || this.ate ? [this.desde, this.ate] : null
            ),
          100
        );
    }
  },
  components: {
    Datepicker
  },
  watch: {
    desde(val) {
      this.inputChanged();
    },
    ate(val) {
      this.inputChanged();
    },
    value(val) {
      this.desde = val != null ? val[0] : null;
      this.ate = val != null ? val[1] : null;
    }
  }
};
</script>

<style>
.v-tabs__items {
  overflow: inherit !important;
}

.dataCampoInput {
  border: solid #ccc 1px;
  width: 100px;
}
</style>
